function Authentication() {
    return (
        <div>
            Authentication
        </div>
    );
}

export default Authentication;